"use strict";

exports.__esModule = true;
exports.filterInboxResults = filterInboxResults;

function filterInboxResults(results = [], section = undefined, value = undefined) {
  // app
  if (section === "app" && value) {
    return results.filter(item => {
      return item['appName'] === value;
    });
  } else if (section === "app") {
    return results.filter(item => {
      return typeof item['appName'] !== 'undefined';
    });
  } // type


  if (section === "type" && value) {
    return results.filter(item => {
      return item['inboxType'] === value;
    });
  } else if (section === "type") {
    return results.filter(item => {
      return typeof item['inboxType'] !== 'undefined';
    });
  } // owner


  if (section === "owner" && value) {
    return results.filter(item => {
      return item['ownerName'] === value;
    });
  } else if (section === "owner") {
    return results.filter(item => {
      return typeof item['ownerName'] !== 'undefined';
    });
  }
}